(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const row = document.querySelector('.footer-utilities .utilities');
    if (!row || !('IntersectionObserver' in window)) return;

    const root = document.documentElement;
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        root.style.setProperty('--footer-utilities-height', `${entry.boundingClientRect.height}px`);
        root.setAttribute('data-footer-utilities-in-view', '');
      } else {
        root.removeAttribute('data-footer-utilities-in-view');
      }
    }).observe(row);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const close = target.closest('.search-panel__close--page');
    if (!close) return;

    // Only take over the link when there's somewhere on this store to go back to.
    let sameOriginReferrer = false;
    try {
      sameOriginReferrer = Boolean(document.referrer) && new URL(document.referrer).origin === location.origin;
    } catch {
      sameOriginReferrer = false;
    }

    if (!sameOriginReferrer || history.length <= 1) return;

    event.preventDefault();
    history.back();
  });

  } catch(e) { console.error(e); }
})();
})();
